export const Admin = '777cfd20-2970-4b24-a771-9beef2022729'
export const Director = '4ebc8214-d137-466c-a7a9-a4e79f267d4a'
export const SupervisorManager = '11f387a8-a665-4f67-ad8d-9e1a7bb51408'
export const ExecAssistant = '4514fac2-c42c-4dbe-9639-3297d0c3fba1'
export const CadetInterSenior = '3e0af407-b89d-4627-beb0-716a91a5034d'
